import { put, takeLatest, all, select } from 'redux-saga/effects';
import { notification } from 'antd';
import TrackerActions from '@Actions/trackerActions';
import BOMActions, { bomActionTypes } from '../actions/bomActions';
import BOMServices from '../services/bomServices';

/**
 * @param action
 */
function* _createBOM(action) {
  try {
    yield put(BOMActions.createBOMLoading(true));
    const state = yield select();
    const isV2Enabled = state.UserReducers?.user?.tenant_info?.global_config?.settings?.enable_jw_v2;
    let bom;
    if(isV2Enabled) {
      bom = yield BOMServices.createBOMv2(action.payload);
    } else {
      bom = yield BOMServices.createBOM(action.payload);
    }
    if (bom.success) {
      yield put(TrackerActions.trackAction(bomActionTypes.CREATE_BOM.SUCCESS, bom.data));
      notification.open({
        type: 'success',
        message: 'Bill of Material successfully created',
        duration: 4,
        placement: 'top',
      });
      action.callback(bom?.data?.[0]);
      yield put(BOMActions.createBOMLoading(false));
    } else {
      notification.open({
        type: 'error',
        message: bom?.message,
        duration: 4,
        placement: 'top',
      });
      yield put(BOMActions.createBOMLoading(false));
    }
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
    });
    yield put(BOMActions.createBOMLoading(false));
    yield put(TrackerActions.trackAction(bomActionTypes.CREATE_BOM.ERROR, error));
  }
}

/**
 *
 */
function* createBOM() {
  yield takeLatest(bomActionTypes.CREATE_BOM.REQUEST, _createBOM);
}

/**
 * @param action
 */
function* _updateBOM(action) {
  try {
    yield put(BOMActions.updateBOMLoading(true));
    const state = yield select();
    const isV2Enabled = state.UserReducers?.user?.tenant_info?.global_config?.settings?.enable_jw_v2;
    let bom;
    if(isV2Enabled) {
      bom = yield BOMServices.updateBOMv2(action.payload);
    } else {
      bom = yield BOMServices.updateBOM(action.payload);
    }
    if (bom.success) {
      yield put(TrackerActions.trackAction(bomActionTypes.UPDATE_BOM.SUCCESS, bom.data));
      notification.open({
        type: 'success',
        message: 'Bill of Material successfully updated',
        duration: 4,
        placement: 'top',
      });
      action.callback(bom);
      yield put(BOMActions.updateBOMLoading(false));
    } else {
      notification.open({
        type: 'error',
        message: bom?.message,
        duration: 4,
        placement: 'top',
      });
      yield put(BOMActions.updateBOMLoading(false));
    }
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
      placement: 'top',
    });
    yield put(BOMActions.updateBOMLoading(false));
    yield put(TrackerActions.trackAction(bomActionTypes.UPDATE_BOM.ERROR, error));
  }
}

/**
 *
 */
function* updateBOM() {
  yield takeLatest(bomActionTypes.UPDATE_BOM.REQUEST, _updateBOM);
}

/**
 * @param action
 */
function* _getBOM(action) {
  try {
    yield put(BOMActions.getBOMLoading(true));
    const {
      orgId, tenantId, bomId, productSkuId, status, page, limit, searchKeyword, tenantDepartmentId, responseType, searchBomByRm
    } = action;
    const billOfMaterials = yield BOMServices.getBOM(orgId, tenantId, bomId, productSkuId, status, page, limit, searchKeyword, tenantDepartmentId, responseType, 'first_level', searchBomByRm);
    yield put(BOMActions.getBOMSuccess(billOfMaterials));
    yield put(BOMActions.getBOMLoading(false));
    if (action.callback) {
      action.callback();
    }
  } catch (error) {
    yield put(BOMActions.getBOMLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(bomActionTypes.GET_BOM.ERROR, error));
  }
}

/**
 *
 */
function* getBOM() {
  yield takeLatest(bomActionTypes.GET_BOM.REQUEST, _getBOM);
}

/**
 * @param action
 */
function* _getBOMById(action) {
  try {
    yield put(BOMActions.getBOMByIdLoading(true));
    const {
      orgId, tenantId, bomId, tenantDepartmentId, bomViewType, callback, getBOMById
    } = action;
    const selectedBOM = yield BOMServices.getBOM(orgId, tenantId, bomId, '', '', 1, 10, '', tenantDepartmentId, 'view', bomViewType);
    yield put(BOMActions.getBOMByIdSuccess(selectedBOM?.bill_of_material?.[0] || {}));
    if (callback) callback(selectedBOM?.bill_of_material?.[0] || {});
    yield put(BOMActions.getBOMByIdLoading(false));
  } catch (error) {
    yield put(BOMActions.getBOMByIdLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(bomActionTypes.GET_BOM_BY_ID.ERROR, error));
  }
}

/**
 *
 */
function* getBOMById() {
  yield takeLatest(bomActionTypes.GET_BOM_BY_ID.REQUEST, _getBOMById);
}

/**
 * @param action
 */
function* _updateBOMStatus(action) {
  try {
    yield put(BOMActions.updateBOMStatusLoading(true));
    const bom = yield BOMServices.updateBOMStatus(action.payload);

    if (bom.success) {
      notification.open({
        type: 'success',
        message: 'Bill of Material status successfully updated',
        duration: 4,
        placement: 'top',
      });
      if (action?.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: bom?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(BOMActions.updateBOMStatusLoading(false));
  } catch (error) {
    yield put(BOMActions.updateBOMStatusLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(bomActionTypes.UPDATE_STATUS_BOM.ERROR, error));
  }
}

/**
 *
 */
function* updateBOMStatus() {
  yield takeLatest(bomActionTypes.UPDATE_STATUS_BOM.REQUEST, _updateBOMStatus);
}

/**
 * @param action
 */
function* _deleteBOM(action) {
  try {
    yield put(BOMActions.deleteBOMLoading(true));
    const bom = yield BOMServices.deleteBOM(action.payload);

    if (bom.success) {
      notification.open({
        type: 'success',
        message: 'Bill of Material successfully deleted',
        duration: 4,
        placement: 'top',
      });
      if (action?.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: bom?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(BOMActions.deleteBOMLoading(false));
  } catch (error) {
    yield put(BOMActions.deleteBOMLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(bomActionTypes.DELETE_BOM.ERROR, error));
  }
}

/**
 *
 */
function* deleteBOM() {
  yield takeLatest(bomActionTypes.DELETE_BOM.REQUEST, _deleteBOM);
}

/**
 * @param action
 */
function* _updateBOMWorkflowStep(action) {
  try {
    yield put(BOMActions.updateBOMWorkflowStepLoading(true));
    const bom = yield BOMServices.updateBOMWorkflowStep(action.payload);
    if (bom.success) {
      notification.open({
        type: 'success',
        message: 'Bill of Material successfully updated',
        duration: 4,
        placement: 'top',
      });
      if (action?.callback) {
        action.callback();
      }
    } else {
      notification.open({
        type: 'error',
        message: bom?.message,
        duration: 4,
        placement: 'top',
      });
    }
    yield put(BOMActions.updateBOMWorkflowStepLoading(false));
  } catch (error) {
    yield put(BOMActions.updateBOMWorkflowStepLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(bomActionTypes.UPDATE_BOM_WORKFLOW_STEP.ERROR, error));
  }
}

/**
 *
 */
function* updateBOMWorkflowStep() {
  yield takeLatest(bomActionTypes.UPDATE_BOM_WORKFLOW_STEP.REQUEST, _updateBOMWorkflowStep);
}

/**
 * @param action
 */
function* _activateBOM(action) {
  try {
    yield put(BOMActions.activateBOMLoading(true));
    const bom = yield BOMServices.activateBOM(action.payload);
    if (bom.success) {
      notification.open({
        type: 'success',
        message: 'We are processing your request. Please check the status on bulk imports section.',
        duration: 4,
        placement: 'top',
      });
      action.callback();
      yield put(BOMActions.activateBOMLoading(false));
    } else {
      notification.open({
        type: 'error',
        message: 'Error in activating Bill of Material',
        duration: 4,
        placement: 'top',
      });
      yield put(BOMActions.activateBOMLoading(false));
    }
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
    });
    yield put(BOMActions.activateBOMLoading(false));
    yield put(TrackerActions.trackAction(bomActionTypes.ACTIVATE_BOM.ERROR, error));
  }
}

/**
 *
 */
function* activateBOM() {
  yield takeLatest(bomActionTypes.ACTIVATE_BOM.REQUEST, _activateBOM);
}

/**
 *
 */

// Bulk upload BOM
function* _uploadBOM(action) {
  try {
    yield put(BOMActions.bulkUploadBOMLoading(true));
    const bom = yield BOMServices.bulkUploadBOM(action.payload);
    if (bom.success) {
      if (bom.message) {
        notification.open({
          type: 'success',
          message: bom.message,
          duration: 4,
          placement: 'top',
        });
      }
      action.callback(bom.data);
      yield put(BOMActions.bulkUploadBOMSuccess(bom.data));
      yield put(BOMActions.bulkUploadBOMLoading(false));
    } else {
      notification.open({
        type: 'error',
        message: bom?.message,
        duration: 4,
        placement: 'top',
      });
      yield put(BOMActions.bulkUploadBOMLoading(false));
    }
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
    });
    yield put(BOMActions.bulkUploadBOMLoading(false));
    yield put(TrackerActions.trackAction(bomActionTypes.BULK_UPLOAD_BOM.ERROR, error));
  }
}

/**
 * @param action
 */

function* uploadBOM() {
  yield takeLatest(bomActionTypes.BULK_UPLOAD_BOM.REQUEST, _uploadBOM);
}

function* _getBomJobworks(action) {
  try {
    yield put(BOMActions.getBomJobWorkLoading(true));
    const {
      payload, callback,
    } = action;
    const bomJobworks = yield BOMServices.getBomJobworks(payload);
    yield put(BOMActions.getBomJobWorkSuccess(bomJobworks?.bom_route));
    if (callback) callback(bomJobworks);
    yield put(BOMActions.getBomJobWorkLoading(false));
  } catch (error) {
    yield put(BOMActions.getBomJobWorkLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
  }
}

function* getBomJobworks() {
  yield takeLatest(bomActionTypes.GET_BOM_JW.REQUEST, _getBomJobworks);
}

function* _updateBomJobwork(action) {
  try {
    yield put(BOMActions.updateBomJobworkLoading(true));
    const { payload, callback } = action;
    const bom = yield BOMServices.updateBomJobwork(payload);
    if (bom.success) {
      notification.open({
        type: 'success',
        message: 'Bill of materials steps updated successfully.',
        duration: 4,
        placement: 'top',
      });
      callback();
      yield put(BOMActions.updateBomJobworkLoading(false));
    } else {
      notification.open({
        type: 'error',
        message: bom?.message,
        duration: 4,
        placement: 'top',
      });
      yield put(BOMActions.updateBomJobworkLoading(false));
    }
  } catch (error) {
    notification.open({
      type: 'error',
      message: error?.message,
      duration: 4,
    });
    yield put(BOMActions.updateBomJobworkLoading(false));
  }
}

function* updateBomJobwork() {
  yield takeLatest(bomActionTypes.UPDATE_BOM_JW.REQUEST, _updateBomJobwork);
}

export default function* bomSaga() {
  yield all([
    createBOM(), getBOM(), updateBOM(), getBOMById(), updateBOMStatus(), deleteBOM(), updateBOMWorkflowStep(),
    activateBOM(), uploadBOM(), getBomJobworks(), updateBomJobwork(),
  ]);
}
